import Vue from 'vue'
import Vuex from 'vuex'
import ucarStorage from './utils/storage'
import rentData from './utils/rent.json'
import saleData from './utils/sale.json'
import { getServiceCities, getRecruitTextByCityId, getCityConfig } from './api'

Vue.use(Vuex)

const currentCityReset = {
  name: '',
  id: '',
  cityName: '',
  cityId: '',
  hasCar: 0,
  noCar: 0,
  rentCar: 0,
  buyCar: 0,
  selfOperated: 0,
  needNetworkLicense: 0,
  needAcidDetection:0,
  needNetworkCarLicense: 0,
  driverRequire: [],
  carRequire: [],
  needCompanyNetworkLicense: 0,
  needCompanyNetworkCarLicense: 0,
  recruitObject: 0,
  noCrimeCertFlag: false,
}

export default new Vuex.Store({
  state: {
    // 司机犯罪记录拒绝原因缓存
    crimeRejectReason: ucarStorage.getSession('crime-reject-reason'),
    // 判断是不是新招募单
    newRecruit: ucarStorage.getSession('new-recruit'),
    // 判断是不是带车加入
    ownCarJoin: ucarStorage.getSession('own-car-join'),
    // 新司机招募类型，1个人，2企业
    driverType: ucarStorage.getSession('driver-type'),
    // 缓存司机身份信息
    driverInfo: ucarStorage.getSession('driver-info'),
    // 缓存车辆信息
    vehicleInfo: ucarStorage.getSession('vehicle-info'),
    // 身份证号是否变化
    idUpdated: ucarStorage.getSession('id-upDated'),
    // 课后测试详情数据
    trainExamData: ucarStorage.getSession('train-exam-data'),
    // 课后测试详情数据
    trainExamResult: ucarStorage.getSession('train-exam-result'),
    // 培训全局配置
    trainConfig: ucarStorage.getSession('train-config') || {
      remainMinutes: 60
    },




    // -------- 新老数据区分 -------

    // 首页地址，用来保存入口
    indexUrl: ucarStorage.getSession('index-url') || '',
    // 登录类型 1.现版本已报名但尚未签约的司机\新司机 2.老版本已报名但尚未签约的司机
    loginType: ucarStorage.getSession('login-type') || 1,
    // 老司机注册类型 1.自营司机 2.无车优驾司机 3.有车优驾司机 4.企业无车优驾 5.企业有车优驾 6.车队报名
    regType: ucarStorage.getSession('reg-type'),
    // 招募状态对象，包含招募状态和复核状态
    recruitStatus: { recruitStatus: 0, recruitCompoundStatus: 0, ...ucarStorage.getSession('recruit-status') },

    // 招募id -------- 新老复用 ----------
    recruitId: ucarStorage.getSession('recruit-id'),
    // 用户手机号 -------- 新老复用 ----------
    personMobile: ucarStorage.getSession('person-mobile'),


    // 用户基本信息
    personInfo: ucarStorage.getSession('person-info'),
    // 用户车辆信息
    carInfo: ucarStorage.getSession('car-info'),
    // 用户车队信息
    teamInfo: ucarStorage.getSession('team-info'),
    // 提交与验证需要的所有信息
    submitInfo: ucarStorage.getSession('submit-info'),
    // 渠道类型（0：无邀请，1：第三方，2：url分享，3：二维码）
    channelType: ucarStorage.getSession('channel-type'),
    // 企业ID
    companyId: ucarStorage.getSession('company-id'),
    // 企业名称
    companyName: ucarStorage.getSession('company-name') || '',
    // 邀请码
    inviteCode: ucarStorage.getSession('invite-code'),
    // 微信参数
    wxQuery: ucarStorage.getSession('wx-query'),
    // 服务城市列表
    serviceCities: ucarStorage.getSession('service-cities') || [],
    // 当前选择的服务城市
    currentCity: {
      ...currentCityReset,
      ...ucarStorage.getSession('current-city')
    },
    // 审核未通过数据, baseInfo保存表单信息，photoInfo表示照片信息
    disapproveInfo: {
      baseInfo: null,
      photoInfo: null,
      needModify: [],
      errors: {},
      errorType: 0,
      ...ucarStorage.getSession('disapprove-info')
    },
    // 重新提交审核的数据
    modifyInfo: ucarStorage.getSession('modify-info'),
    // 租车静态展示数据
    rentData,
    // 买买车静态展示数据
    saleData,
    // 永久缓存的用户数据(上限为10个)
    cachedInfo: ucarStorage.getStorage('cached-info') || [],
    // 渠道来源（从哪里进入的本系统）
    from: ucarStorage.getSession('from') || 'url'
  },
  getters: {
    vuexDriverType: state => state.driverType,
    vuexDriverInfo: state => state.driverInfo,
    vuexVehicleInfo: state => state.vehicleInfo,
    vuexIdUpdated: state => state.idUpdated,
    vuexTrainExamData: state => state.trainExamData,
    vuexTrainExamResult: state => state.trainExamResult,
    vuexTrainConfig: state => state.trainConfig,
    vuexIndexUrl: state => state.indexUrl,
    vuexLoginType: state => state.loginType,
    vuexRegType: state => state.regType,
    vuexRecruitStatus: state => state.recruitStatus,
    // 加入模式 0.出错 1.个人 2.企业
    vuexJoinMode: state => '23'.indexOf(state.regType) !== -1 ? 1 : '45'.indexOf(state.regType) !== -1 ? 2 : 0,
    vuexRecruitId: state => state.recruitId,
    vuexPersonMobile: state => state.personMobile,
    vuexPersonInfo: state => state.personInfo,
    vuexCarInfo: state => state.carInfo,
    vuexTeamInfo: state => state.teamInfo,
    vuexSubmitInfo: state => state.submitInfo,
    vuexChannelType: state => state.channelType,
    vuexCompanyId: state => state.companyId,
    vuexCompanyName: state => state.companyName,
    vuexInviteCode: state => state.inviteCode,
    vuexWxQuery: state => state.wxQuery,
    vuexServiceCities: state => state.serviceCities,
    vuexCurrentCity: state => state.currentCity,
    vuexDisapproveInfo: state => state.disapproveInfo,
    vuexModifyInfo: state => state.modifyInfo,
    vuexRentData: state => state.rentData,
    vuexSaleData: state => state.saleData,
    vuexCachedInfo: state => state.cachedInfo,
    vuexFrom: state => state.from,
    vuexOwnCarJoin: state => state.ownCarJoin,
    vuexNewRecruit: state => state.newRecruit,
    vuexCrimeRejectReason: state => state.crimeRejectReason
  },
  mutations: {
    setVuexNewRecruit: (state, payload) => {
      state.newRecruit = payload
      ucarStorage.setSession('new-recruit', payload)
    },
    setVuexOwnCarJoin: (state, payload) => {
      state.ownCarJoin = payload
      ucarStorage.setSession('own-car-join', payload)
    },
    setVuexCrimeRejectReason: (state, payload) => {
      state.crimeRejectReason = payload
      ucarStorage.setSession('crime-reject-reason', payload)
    },
    setVuexDriverType: (state, payload) => {
      state.driverType = payload
      ucarStorage.setSession('driver-type', payload)
    },
    setVuexDriverInfo: (state, payload) => {
      state.driverInfo = payload
      ucarStorage.setSession('driver-info', payload)
    },
    setVuexVehicleInfo: (state, payload) => {
      state.vehicleInfo = payload
      ucarStorage.setSession('vehicle-info', payload)
    },
    setVuexIdUpdated: (state, payload) => {
      state.idUpdated = payload
      ucarStorage.setSession('id-updated', payload)
    },
    setVuexTrainExamData: (state, payload) => {
      state.trainExamData = payload
      ucarStorage.setSession('train-exam-data', payload)
    },
    setVuexTrainExamResult: (state, payload) => {
      state.trainExamResult = payload
      ucarStorage.setSession('train-exam-result', payload)
    },
    setVuexTrainConfig: (state, payload) => {
      state.trainConfig = payload
      ucarStorage.setSession('train-config', payload)
    },
    setVuexIndexUrl: (state, payload) => {
      state.indexUrl = payload
      ucarStorage.setSession('index-url', payload)
    },
    setVuexLoginType: (state, payload) => {
      state.loginType = payload
      ucarStorage.setSession('login-type', payload)
    },
    setVuexRegType: (state, payload) => {
      state.regType = payload
      ucarStorage.setSession('reg-type', payload)
    },
    setVuexRecruitStatus: (state, payload) => {
      state.recruitStatus = payload
      ucarStorage.setSession('recruit-status', payload)
    },
    setVuexRecruitId: (state, payload) => {
      state.recruitId = payload
      ucarStorage.setSession('recruit-id', payload)
    },
    setVuexPersonMobile: (state, payload) => {
      state.personMobile = payload
      ucarStorage.setSession('person-mobile', payload)
    },
    setVuexPersonInfo: (state, payload) => {
      state.personInfo = { ...state.personInfo, ...payload }
      ucarStorage.setSession('person-info', state.personInfo)
    },
    setVuexCarInfo: (state, payload) => {
      state.carInfo = { ...state.carInfo, ...payload }
      ucarStorage.setSession('car-info', state.carInfo)
    },
    setVuexTeamInfo: (state, payload) => {
      state.teamInfo = { ...state.teamInfo, ...payload }
      ucarStorage.setSession('team-info', state.teamInfo)
    },
    setVuexSubmitInfo: (state, payload) => {
      state.submitInfo = { ...state.submitInfo, ...payload }
      ucarStorage.setSession('submit-info', state.submitInfo)
    },
    setVuexChannelType: (state, payload) => {
      state.channelType = payload
      ucarStorage.setSession('channel-type', payload)
    },
    setVuexCompanyId: (state, payload) => {
      state.companyId = payload
      ucarStorage.setSession('company-id', payload)
    },
    setVuexCompanyName: (state, payload) => {
      state.companyName = payload
      ucarStorage.setSession('company-name', payload)
    },
    setVuexInviteCode: (state, payload) => {
      state.inviteCode = payload
      ucarStorage.setSession('invite-code', payload)
    },
    setVuexWxQuery: (state, payload) => {
      state.wxQuery = payload
      ucarStorage.setSession('wx-query', payload)
    },
    setVuexServiceCities: (state, payload) => {
      state.serviceCities = payload
      ucarStorage.setSession('service-cities', payload)
    },
    setVuexCurrentCity: (state, payload) => {
      state.currentCity = { ...state.currentCity, ...payload }
      console.log(state.currentCity)
      ucarStorage.setSession('current-city', state.currentCity)
    },
    setVuexDisapproveInfo: (state, payload) => {
      state.disapproveInfo = { ...state.disapproveInfo, ...payload }
      ucarStorage.setSession('disapprove-info', state.disapproveInfo)
    },
    setVuexModifyInfo: (state, payload) => {
      state.modifyInfo = { ...state.modifyInfo, ...payload }
      ucarStorage.setSession('modify-info', state.modifyInfo)
    },
    setVuexCachedInfo: (state, payload) => {
      const index = state.cachedInfo.findIndex(item => item.mobile === payload.mobile)
      if (index === -1) {
        if (state.cachedInfo.length === 10) state.cachedInfo.shift()
        state.cachedInfo.push(payload)
      } else {
        state.cachedInfo[index] = payload
      }
      ucarStorage.setStorage('cached-info', state.cachedInfo)
    },
    setVuexFrom: (state, payload) => {
      state.from = payload
      ucarStorage.setSession('from', payload)
    },
    resetInfo: (state) => {
      state.loginType = 1
      state.regType = null
      state.personMobile = null
      state.personInfo = null
      state.carInfo = null
      state.submitInfo = null
      state.disapproveInfo = { baseInfo: null, photoInfo: null, needModify: [], errors: {}, errorType: 0 }
      state.modifyInfo = null
      state.driverInfo = null
      state.vehicleInfo = null
      ucarStorage.removeSession('login-type')
      ucarStorage.removeSession('reg-type')
      ucarStorage.removeSession('person-mobile')
      ucarStorage.removeSession('person-info')
      ucarStorage.removeSession('car-info')
      ucarStorage.removeSession('submit-info')
      ucarStorage.removeSession('disapprove-info')
      ucarStorage.removeSession('modify-info')
      ucarStorage.removeSession('driver-info')
      ucarStorage.removeSession('vehicle-info')
    },
    resetRecommendInfo: (state) => {
      state.channelType = null
      state.inviteCode = null
      state.wxQuery = null
      ucarStorage.removeSession('channel-type')
      ucarStorage.removeSession('invite-code')
      ucarStorage.removeSession('wx-query')
    }
  },
  actions: {
    setVuexNewRecruit (state, val) {
      state.commit('setVuexNewRecruit', val)
    },
    setVuexOwnCarJoin (state, val) {
      state.commit('setVuexOwnCarJoin', val)
    },
    setVuexCrimeRejectReason (state, val) {
      state.commit('setVuexCrimeRejectReason', val)
    },
    setVuexDriverType (state, val) {
      state.commit('setVuexDriverType', val)
    },
    setVuexDriverInfo (state, val) {
      state.commit('setVuexDriverInfo', val)
    },
    setVuexVehicleInfo (state, val) {
      state.commit('setVuexVehicleInfo', val)
    },
    setVuexIdUpdated (state, val) {
      state.commit('setVuexIdUpdated', val)
    },
    setVuexTrainExamData ({ commit }, val) {
      commit('setVuexTrainExamData', val)
    },
    setVuexTrainExamResult ({ commit }, val) {
      commit('setVuexTrainExamResult', val)
    },
    setVuexTrainConfig ({ commit }, val) {
      commit('setVuexTrainConfig', val)
    },
    // 首页地址赋值后不可重复赋值
    setVuexIndexUrl (state, val) {
      if (state.indexUrl) return
      state.commit('setVuexIndexUrl', val)
    },
    setVuexLoginType ({ commit }, val) {
      commit('setVuexLoginType', val)
    },
    setVuexRegType ({ commit }, val) {
      commit('setVuexRegType', val)
    },
    setVuexRecruitStatus ({ commit }, val) {
      commit('setVuexRecruitStatus', val)
    },
    setVuexRecruitId ({ commit }, val) {
      commit('setVuexRecruitId', val)
    },
    setVuexPersonMobile ({ commit }, val) {
      commit('setVuexPersonMobile', val)
    },
    setVuexPersonInfo ({ commit }, val) {
      commit('setVuexPersonInfo', val)
    },
    setVuexCarInfo ({ commit }, val) {
      commit('setVuexCarInfo', val)
    },
    setVuexTeamInfo ({ commit }, val) {
      commit('setVuexTeamInfo', val)
    },
    setVuexSubmitInfo ({ commit }, val) {
      commit('setVuexSubmitInfo', val)
    },
    setVuexChannelType ({ commit }, val) {
      commit('setVuexChannelType', val)
    },
    setVuexCompanyId ({ commit }, val) {
      commit('setVuexCompanyId', val)
    },
    setVuexCompanyName ({ commit }, val) {
      commit('setVuexCompanyName', val)
    },
    setVuexInviteCode ({ commit }, val) {
      commit('setVuexInviteCode', val)
    },
    setVuexWxQuery ({ commit }, val) {
      commit('setVuexWxQuery', val)
    },
    async setVuexServiceCities ({ commit }, data) {
      // 企业招募忽略城市招募状态，如果为企业招募也就是companyId存在则城市 带车置为1
      const companyId = data.companyId
      const res = await getServiceCities(data)
      let result = res.serviceCityList
      result = result.filter(item => {
        if (companyId) {
          // 企业招募招募对象类型不匹配城市
          if (item.recruitObject === 2) return false
        } else {
          // 个人招募招募对象类型不匹配城市
          if (item.recruitObject === 1) return false
        }
        return true
      }).map(item => {
        companyId && (item.hasCar = 1)
        return item
      })

      commit('setVuexServiceCities', result)
      return Promise.resolve(res)
    },
    async setVuexCurrentCity ({ commit }, val) {
      let body = {
        ...currentCityReset
      }
      if (val.id && val.id !== '') {
        const re = await getCityConfig({serviceCityId: val.id})
        const res = await getRecruitTextByCityId(val.id)
        body = {
          ...re,
          ...res,
          cityId: res.cityId,
          cityName: res.cityName,
          id: res.cityId,
          name: res.cityName,
          noCrimeCertFlag: res.noCrimeCertFlag,
          needNetworkLicense: res.drivingLicense,
          needNetworkCarLicense: res.onLineVehicleTransportationLicense,
          needCompanyNetworkLicense: res.companyDrivingLicense, // 企业网络预约出租汽车驾驶证
          needCompanyNetworkCarLicense: res.companyTransportCertificate, // 企业网络预约出租汽车运输证
          needAcidDetection:res.nucleicAcidDetection || 0, // 核酸校验
          recruitObject: res.recruitObject, // 招募对象类型
          // 根据re.enableComfort展示专车/舒享司机/车辆要求  0：专车  1：舒享
          driverRequire: re.enableComfort===0?re.driverRequire.split('\n').filter(item => !!item.replace(/\s/g, '')):re.comfortDriverRequire.split('\n').filter(item => !!item.replace(/\s/g, '')),
          carRequire: re.enableComfort===0?re.vehicleRequire.split('\n').filter(item => !!item.replace(/\s/g, '')):re.comfortVehicleRequire.split('\n').filter(item => !!item.replace(/\s/g, '')),
          ...val
        }
      }
      commit('setVuexCurrentCity', {...val, ...body})
    },
    setVuexDisapproveInfo ({ commit }, val) {
      commit('setVuexDisapproveInfo', val)
    },
    setVuexModifyInfo ({ commit }, val) {
      commit('setVuexModifyInfo', val)
    },
    setVuexCachedInfo ({ commit }, val) {
      commit('setVuexCachedInfo', val)
    },
    setVuexFrom ({ commit }, val) {
      commit('setVuexFrom', val)
    },
    resetInfo ({ commit }) {
      commit('resetInfo')
    },
    resetRecommendInfo ({ commit }) {
      commit('resetRecommendInfo')
    }
  }
})
